<template>
  <button
    :aria-label="label"
    class="raw-glass rounded-full hidden h-36 w-36 shrink-0 items-center justify-center transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] active:border-[white] active:bg-[white] md:flex md:hover:border-[white] md:hover:bg-[white]"
    type="button"
    @click="$emit('click')"
  >
    <svg
      fill="none"
      height="14"
      viewBox="0 0 12 12"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.234 7.2a.4.4 0 0 1 .566.566l-2.366 2.366h1.288a.4.4 0 0 1 0 .8H1.469a.4.4 0 0 1-.4-.4V8.335a.4.4 0 0 1 .8 0v1.233zm2.966 0a.4.4 0 0 1 .566 0l2.366 2.367v-1.29a.4.4 0 1 1 .8 0v2.256a.4.4 0 0 1-.4.4l-2.198-.001a.4.4 0 0 1 0-.8h1.231L7.2 7.766a.4.4 0 0 1 0-.566M1.067 3.723V1.468c0-.22.18-.4.4-.4h2.199a.4.4 0 0 1 0 .8H2.435L4.8 4.235a.4.4 0 1 1-.566.565L1.868 2.434v1.289a.4.4 0 0 1-.8 0m9.866-.057a.4.4 0 0 1-.801 0V2.434L7.766 4.8a.4.4 0 1 1-.566-.565l2.365-2.367H8.278a.4.4 0 0 1 0-.8h2.254a.4.4 0 0 1 .4.4z"
        fill="currentColor"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
// The `#actions` control that grows a panel's subject into the extended reader, shared by
// the article and metal panels. The ≥768 gate lives here rather than in each caller:
// below that width the sheet is already full-width, and a caller that forgot the classes
// would ship a button opening a modal that refuses to mount (`ExtendedReader` gates on
// `useIsPhone` for the same seam). The label arrives translated, so each panel keeps its
// own message id and this carries no strings.
defineProps<{ label: string }>()

defineEmits<{ click: [] }>()
</script>
